import { createSlice } from "@reduxjs/toolkit";
import { iUserState, REDUCER_NAME } from "./Types";
import { getUserProfileInfo } from "./ThunkActions";

const initialState: iUserState = {
  isLoading: false,
  user: null,
  token: null,
  isAuthenticated: false,
  errorMessage: null,
};

export const userSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetUserState: () => {
      return initialState;
    },
    logout: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getUserProfileInfo.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getUserProfileInfo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.user = action.payload?.data.user || null;
      state.isAuthenticated = true;
    })
    .addCase(getUserProfileInfo.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = "An error occurred";
    });
    
  },


});

export const { resetUserState, logout } = userSlice.actions;

export default userSlice.reducer;
